
const urlMode = 'list'; // list 或 default
export { urlMode };
export default [
  'https://api.optcomcfs.com',
  'https://api.opthout.com',
  'https://api.optcoin.com',
  'https://api.optcoinap.com',
]
